import { useCallback } from "react";
import { ContactBlock } from "@/components/sections/ContactBlock";
import { useT } from "@/i18n/LocaleProvider";
import { useSearch } from "@tanstack/react-router";
import { trackMetaPixel, trackEvent } from "@/lib/analytics";
import { resolveOrigin } from "@/lib/origin";
import type { LeadInput } from "@/lib/lead";




export function ContatoPage() {
  const t = useT();
  const search = useSearch({ strict: false }) as { src?: string; vertical?: string } | undefined;
  const urlSrc = search?.src;
  const vertical = search?.vertical;

  const handleSuccess = useCallback(
    (data: LeadInput) => {
      // Resolvido no submit (client-side) para que UTMs/referer/sessionStorage
      // estejam disponíveis — o valor do SSR seria sempre indefinido.
      const origin = resolveOrigin(urlSrc);
      const src = origin.source;

      const [firstName, ...rest] = (data.name ?? "").trim().split(/\s+/);
      const lastName = rest.join(" ");
      const contentCategory =
        src === "clinicas" && vertical ? `clinicas_${vertical}` : src;

      trackMetaPixel(
        "Lead",
        {
          content_name: `form_contato_${src}`,
          content_category: contentCategory,
          source: src,
          origin_page: origin.origin_page || undefined,
          previous_page: origin.previous_page || undefined,
          landing_path: origin.landing_path || undefined,
          referrer_domain: origin.referrer_domain || undefined,
          is_campaign: origin.isCampaign,
          attribution_method: origin.attribution_method,
        },
        {
          email: data.email,
          phone: data.phone,
          first_name: firstName || undefined,
          last_name: lastName || undefined,
          country: "br",
        },
      );
      trackEvent("lead_submit", {
        source: src,
        vertical: vertical ?? undefined,
        page: "contato",
        origin_page: origin.origin_page || undefined,
        previous_page: origin.previous_page || undefined,
        landing_path: origin.landing_path || undefined,
        referrer_domain: origin.referrer_domain || undefined,
        is_campaign: origin.isCampaign,
        attribution_method: origin.attribution_method,
      });
    },
    [urlSrc, vertical],
  );

  return (
    <>
      <section className="gradient-hero relative overflow-hidden pt-24 pb-12">
        <div className="circuit-pattern absolute inset-0 opacity-30" />
        <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight md:text-5xl">
            {t.contactPage.titlePrefix}
            <span className="gradient-text">{t.contactPage.titleHighlight}</span>
            {t.contactPage.titleSuffix}
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
            {t.contactPage.description}
          </p>
        </div>
      </section>

      <ContactBlock
        source="contact"
        eyebrow={t.contactPage.eyebrow}
        onLeadSuccess={handleSuccess}
      />
    </>
  );
}
